import React, { useContext, useEffect, useState } from 'react'
import ReactWhatsapp from 'react-whatsapp';
import { items } from './componenets/items'


const AppContext = React.createContext();

const getLocalStorage = () => {
    let bag = localStorage.getItem('bag');
    if (bag) {
        return JSON.parse(localStorage.getItem('bag'))
    } else {
        return []
    }
}


export const AppProvider = ({ children }) => {
    const [products, setProducts] = useState([])
    const [bag, setBag] = useState(getLocalStorage())
    const [total, setTotal] = useState(0)
    const [totalItems, setTotalItem] = useState(0)
    let totalPrice = 0;
    let totalItemVar = 0;
    const [alert, setAlert] = useState({ show: false, msg: '' })
    const [buying, setBuying] = useState(null)
    const [secondBag, setSecondBag] = useState([])


    const addToBag = (id) => {
        const theItem = products.filter((prd) => prd.id === id);
        const theItemAgain = bag.find((item) => item.id === id);
        theItem[0].amount = 1;


        if (theItemAgain) {
            setAlert({ show: true, msg: 'item added to bag' })
            const timer = setTimeout(() => {
                setAlert({ show: false, msg: '' })
            }, 2000);
            return () => clearTimeout(timer);
        } else {
            setBag((oldItem) => {
                return [...oldItem, ...theItem]
            })
        }
    }

    const amountHandle = (value, id) => {
        if (value === 'inc') {

            let theItem = bag.find((item) => item.id === id);
            if (theItem.amount > theItem.inStock - 1) {
                setAlert({ show: true, msg: 'no more in the stock' })
                const timer = setTimeout(() => {
                    setAlert({ show: false, msg: '' })
                }, 2000);
                return () => clearTimeout(timer);
            } else {
                theItem.amount += 1
                setBag((oldItems) => {
                    return [...oldItems]
                })
            }
        }
        if (value === 'dec') {

            let theItem = bag.find((item) => item.id === id);
            if (theItem.amount <= 1) {
                setBag(() => {
                    const newIems = bag.filter((item) => item.id !== id)
                    return [...newIems]
                })
            } else {
                theItem.amount -= 1
                setBag((oldItems) => {
                    return [...oldItems]
                })
            }
        }
        if (value === 'remove') {

            setBag(() => {
                const newIems = bag.filter((item) => item.id !== id)
                return [...newIems]
            })
        }
    }

    const totalHandle = () => {
        bag.map((item) => {
            totalPrice += (item.price * item.amount)
            totalItemVar += item.amount;
        })
        setTotal(totalPrice)
        setTotalItem(totalItemVar)
    }
    const sizeHandle = (size, id) => {
        const theItem = bag.filter((item) => item.id === id);
        theItem[0].chossenSize = size;
    }

    useEffect(() => {
        totalHandle()
        localStorage.setItem('bag', JSON.stringify(bag));
    }, [bag])

    useEffect(() => {
        setProducts(items)
        window.scrollTo(0, 0)
    }, [])

    return <AppContext.Provider value={{
        products,
        addToBag,
        bag,
        amountHandle,
        total,
        totalItems,
        alert,
        setBuying,
        buying,
        sizeHandle,
        secondBag
    }}>
        {children}
    </AppContext.Provider>
}

export const useGlobalContext = () => {
    return useContext(AppContext)
}
